module.exports = __webpack_public_path__ + "img/topicDIYGardening.9e260512.svg";